import moduleLoader from "flow/wrappers/moduleLoader";
import $ from "jquery";
import deferred from "flow/promise/deferred";
import MyFlow from "flow/MyFlow";

function createAuthorizationManager(myFlow: MyFlow, authorizationManagerId: string) {
    const dfd = deferred<any>(myFlow);

    moduleLoader
        .requireSingleAsync(authorizationManagerId)
        .then(function (authorizationManager) {
            if (authorizationManager && authorizationManager.default) {
                dfd.resolve(authorizationManager.default);
            } else {
                dfd.resolve(authorizationManager);
            }
        })
        .catch(function (err) {
            if (err.requireModules) {
                $(err.requireModules).each(function (_, failedModuleId) {
                    myFlow.error("Failed to load " + failedModuleId);
                });
            }
            dfd.reject(err);
        });

    return dfd.promise();
}

export default {
    createAuthorizationManager: createAuthorizationManager
};
